import React, { useState, useEffect } from 'react';
import './DBSettings.css';

const DBSettings = () => {
  // API 베이스 URL 설정 (App.js와 동일한 로직)
  const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? `http://${window.location.hostname}:3002` : '');

  const [currentStatus, setCurrentStatus] = useState(null);
  const [testResult, setTestResult] = useState(null);
  const [testing, setTesting] = useState(false);

  // DB 설정 (단일 DB)
  const dbConfig = {
    name: 'DocuAI DB',
    server: '121.156.116.133',
    port: 52785,
    database: 'DOCUAI',
    user: 'sa',
  };

  // 현재 DB 상태 조회
  const fetchCurrentStatus = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/db/status`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        cache: 'no-cache'
      });

      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        setCurrentStatus({
          success: false,
          connected: false,
          error: `API 응답 형식 오류: ${text.substring(0, 50)}...`,
        });
        return;
      }

      const data = await response.json();
      setCurrentStatus(data);
    } catch (error) {
      setCurrentStatus({
        success: false,
        connected: false,
        error: error.message,
      });
    }
  };

  // DB 연결 테스트
  const testConnection = async () => {
    setTesting(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/db/test`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dbConfig)
      });

      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        setTestResult({ success: false, message: 'API 응답 형식 오류' });
        setTesting(false);
        return;
      }

      const data = await response.json();
      setTestResult(data);
    } catch (error) {
      setTestResult({ success: false, message: error.message });
    } finally {
      setTesting(false);
    }
  };

  useEffect(() => {
    fetchCurrentStatus();
  }, []);

  return (
    <div className="db-settings-container">
      <div className="db-settings-header">
        <h2>🔧 데이터베이스 연결 설정</h2>
        <button onClick={fetchCurrentStatus} className="btn-refresh">
          🔄 새로고침
        </button>
      </div>

      {/* 현재 연결 상태 */}
      <div className="current-status">
        <h3>📊 현재 연결 상태</h3>
        {currentStatus ? (
          <div className={`status-box ${currentStatus.connected ? 'connected' : 'disconnected'}`}>
            <div className="status-indicator">
              {currentStatus.connected ? '✅ 연결됨' : '❌ 연결 끊김'}
            </div>
            {currentStatus.connected ? (
              <>
                <div className="status-info">
                  <strong>서버 주소:</strong> <span className="server-address">
                    {currentStatus.configServer || dbConfig.server}
                    :{currentStatus.configPort || dbConfig.port}
                  </span>
                </div>
                <div className="status-info">
                  <strong>데이터베이스:</strong> {currentStatus.database || dbConfig.database}
                </div>
              </>
            ) : (
              <div className="status-error">
                {currentStatus.error && (
                  <div className="error-message">⚠️ {currentStatus.error}</div>
                )}
                <div className="error-hint">
                  💡 <strong>로그인에 성공했다면</strong> 실제로는 DB에 연결되어 있을 수 있습니다.<br />
                  브라우저 개발자 도구(F12) → Console 탭에서 에러를 확인하거나 페이지를 새로고침(Ctrl+F5)해보세요.
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="loading">로딩 중...</div>
        )}
      </div>

      {/* DB 연결 테스트 */}
      <div className="db-test-section">
        <h3>🔍 연결 테스트</h3>

        <div className="db-card">
          <div className="db-card-header">
            <h4>{dbConfig.name}</h4>
            <span className="db-server">{dbConfig.server}:{dbConfig.port}</span>
          </div>

          <div className="db-card-body">
            <div className="db-info">
              <div><strong>데이터베이스:</strong> {dbConfig.database}</div>
              <div><strong>사용자:</strong> {dbConfig.user}</div>
            </div>

            {testResult && (
              <div className={`test-result ${testResult.success ? 'success' : 'error'}`}>
                <div className="result-header">
                  {testResult.success ? '✅ 연결 성공' : '❌ 연결 실패'}
                </div>
                {testResult.success ? (
                  <>
                    <div className="result-detail">
                      <strong>응답 시간:</strong> {testResult.connectTime}ms
                    </div>
                    <div className="result-detail">
                      <strong>SQL Server:</strong> {testResult.version}
                    </div>
                  </>
                ) : (
                  <div className="result-detail error-message">
                    {testResult.message}
                  </div>
                )}
              </div>
            )}

            <div className="db-card-actions">
              <button
                onClick={testConnection}
                disabled={testing}
                className="btn-test"
              >
                {testing ? '테스트 중...' : '🔍 연결 테스트'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DBSettings;
